import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useGetAllPhoneCenters } from "../api/getAllPhoneCenters";
import { IGetPhoneCenter, IPhoneCenterSearchForm } from "../phoneCenter";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";

// All your logic is here
export const usePhoneCentersDataViewLogic = () => {
  const { activeFilters } = useContext(SydFilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "",selectedRows: [],});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetPhoneCenter[]>([]);
  const getAllPhoneCentersQuery = useGetAllPhoneCenters({data: activeFilters as IPhoneCenterSearchForm});
  const { t } = useTranslation();

  const loadingDone = [getAllPhoneCentersQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getAllPhoneCentersQuery].filter(({ isError }) =>isError ? true : false);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getAllPhoneCentersQuery.data ? getAllPhoneCentersQuery.data : [];

  const columnData = [
    {
      columnName: "id",
      columnDisplayName: "Κωδικός",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "description",
      columnDisplayName: "Περιγραφή",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "model",
      columnDisplayName: "Μοντέλο",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "maintenance",
      columnDisplayName: "Συντήρηση",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "unit",
      columnDisplayName: "Μονάδα",
      visible: true,
      columnOrder: 5,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "fct",
      columnDisplayName: "Ανελκυστήρας Πλήθος",
      visible: true,
      columnOrder: 6,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "intercom",
      columnDisplayName: "Εσ. επικ. πλήθος",
      visible: true,
      columnOrder: 7,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "pstn",
      columnDisplayName: "PSTN",
      visible: true,
      columnOrder: 8,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "isdn",
      columnDisplayName: "ISDN",
      visible: true,
      columnOrder: 9,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "lt30Pri",
      columnDisplayName: "30PRI",
      visible: true,
      columnOrder: 10,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "line",
      columnDisplayName: "Line",
      visible: true,
      columnOrder: 11,
      isDraggable: false,
      columnDataType: "String",
    },
  ]

  const columns = useMemo(() => {
    console.log("columnData",columnData)
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  const closeActionModal = () => {
    setModalEvent({ action: "", selectedRows: [] });
  };

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Τηλεφωνικού Κέντρου");
        break;
      case "edit":
        title = t("Επεξεργασία Τηλεφωνικού Κέντρου");
        break;
      case "delete":
        title = t("Διαγραφή Τηλεφωνικού Κέντρου");
        break;
      default:
        break;
    }
    return title;
  };

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0]
      ? [...[selectedRowsOfTable[0].id]]
      : [];
    console.log(
      "selectedRows",
      selectedRows,
      "selectedRowOfTable",
      selectedRowsOfTable,
      "selectedRowOfTable[0]",
      selectedRowsOfTable[0]
    );
    setModalEvent({ action: event.action, selectedRows: selectedRows });
  };



  useEffect(() => {
    setSelectedRowsOfTable([]);
    getAllPhoneCentersQuery.refetch();
  }, [activeFilters]);

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
  };
};
